module.exports = __webpack_public_path__ + "static/media/tommy-commerce.b0b7ac1a.jpg";